import { t } from "../i18n"
// Enables/disables maintenance details fields when the checkbox is toggled
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["enabled", "details"];

  connect() {
    this.apply();
  }

  toggle() {
    this.apply();
  }

  apply() {
    const on = this.hasEnabledTarget ? this.enabledTarget.checked : false;
    if (!this.hasDetailsTarget) return;

    // Show/Hide details section if present via hidden class
    this.detailsTarget.classList.toggle("hidden", !on);

    // Enable/disable all inputs inside details
    this.detailsTarget
      .querySelectorAll("input, select, textarea, button")
      .forEach((el) => {
        el.disabled = !on;
      });
  }
}

